/**
 * Buy Again functionality for Past Orders
 */
/* global buyAgainData */
(function($) {
  'use strict';

  $(document).ready(function() {
    $('.buy-again').on('click', function(e) {
      e.preventDefault();

      const $button = $(this);
      const orderId = $button.data('order-id');
      const originalText = $button.text();

      // Hide button and show spinner in its place
      if (buyAgainData && buyAgainData.loading_icon && buyAgainData.loading_icon !== '') {
        const $spinner = $(`<img src="${buyAgainData.loading_icon}" alt="Loading..." class="buy-again-spinner" style="width: 40px; height: 40px; display: inline-block;" />`);
        $button.hide().after($spinner);
      } else {
        $button.prop('disabled', true).text('Loading...');
      }

      // Send AJAX request
      $.ajax({
        url: buyAgainData.ajax_url,
        type: 'POST',
        data: {
          action: 'buy_again_order',
          order_id: orderId,
          nonce: buyAgainData.nonce,
        },
        success: function(response) {
          if (response.success) {
            // Redirect to checkout
            window.location.href = response.data.checkout_url;
          } else {
            alert(response.data.message || 'An error occurred. Please try again.');
            $('.buy-again-spinner').remove();
            $button.show().prop('disabled', false).text(originalText);
          }
        },
        error: function() {
          alert('An error occurred. Please try again.');
          $('.buy-again-spinner').remove();
          $button.show().prop('disabled', false).text(originalText);
        },
      });
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/buy-again.js